/**
 * Happy Paws design tokens — source de vérité (flyer Canva, mesures histogramme).
 * Isolé des tokens vivants (tokens.css / mui.js) jusqu’à validation.
 */

export const hpColors = {
  primary: '#C1835E',
  primaryPressed: '#B57853',
  primaryDark: '#A66D4C',
  onPrimary: '#FBF5F3',

  secondary: '#E4986D',
  tertiary: '#D2B29F',

  surface: '#FAF1ED',
  surfaceElevated: '#FBF5F3',
  surfaceMuted: '#E8DAD1',

  textPrimary: '#553D2D',
  textSecondary: '#715C50',
  textTertiary: '#715C50',
  textInk: '#2F1D0F',

  accentGold: '#EDA35B',
  border: 'rgba(85, 61, 45, 0.12)',

  // Dérivé sombre (admin preview / futur dark mode)
  darkSurface: '#2A211C',
  darkTextPrimary: '#FAF1ED',
  darkPrimary: '#D49A74',
};

export const hpFonts = {
  display: "'Fraunces', Georgia, 'Times New Roman', serif",
  heading: "'Cormorant Garamond', Georgia, 'Times New Roman', serif",
  script: "'Great Vibes', cursive",
  ui: "'Nunito Sans', system-ui, -apple-system, 'Segoe UI', sans-serif",
};

export const hpFontWeights = {
  regular: 400,
  semibold: 600,
  bold: 700,
};

export const hpTypography = {
  display: { size: '3rem', lineHeight: 1.15, weight: 700, letterSpacing: '-0.02em' },
  h1: { size: '2.25rem', lineHeight: 1.2, weight: 700, letterSpacing: '-0.02em' },
  h2: { size: '1.5rem', lineHeight: 1.25, weight: 700, letterSpacing: '0.08em' },
  h3: { size: '1.25rem', lineHeight: 1.3, weight: 700, letterSpacing: '0.04em' },
  body: { size: '1rem', lineHeight: 1.55, weight: 400, letterSpacing: 'normal' },
  label: { size: '0.875rem', lineHeight: 1.4, weight: 600, letterSpacing: '0.02em' },
  caption: { size: '0.75rem', lineHeight: 1.5, weight: 400, letterSpacing: 'normal' },
  script: { size: '1.75rem', lineHeight: 1.2, weight: 400, letterSpacing: 'normal' },
};

export const hpSpace = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  '2xl': 32,
  '3xl': 48,
  '4xl': 64,
  section: 72,
};

export const hpRadius = {
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  pill: 9999,
};

export const hpShadow = {
  none: 'none',
  surface: '0 2px 12px rgba(47, 29, 15, 0.06)',
  overlay: '0 8px 24px rgba(47, 29, 15, 0.1)',
};

export const hpDuration = {
  fast: 150,
  base: 200,
  slow: 280,
};

export const hpEasing = 'ease-out';

/** Agrégat pratique pour imports uniques */
export const happypawsTokens = {
  colors: hpColors,
  fonts: hpFonts,
  fontWeights: hpFontWeights,
  typography: hpTypography,
  space: hpSpace,
  radius: hpRadius,
  shadow: hpShadow,
  duration: hpDuration,
  easing: hpEasing,
};

export default happypawsTokens;
